import axios from 'axios';
import { configRefs } from '@utils/constants';

async function getNotificationsRequest(user) {
  if (!user) {
    return [];
  }
  const response = await axios.get(`${await configRefs.apis.userdata.get()}/api/Notifications?userID=${encodeURIComponent(user.id)}`);
  return response.data.map(it => {
    const base = {
      id: it.objectID,
      createdAt: new Date(it.created * 1000),
      relatedEntryId: it.entry?.id,
      notifier: it.notifier ? {
        id: it.notifier.id,
        name: it.notifier.name
      } : undefined
    };
    if (it.entry?.type === "forløb") {
      return {
        ...base,
        type: "share.course",
        courseId: it.entry.id
      };
    }
    if (it.type === "deling") {
      return {
        ...base,
        type: "share.componentEntry",
        componentEntryId: it.entry?.id
      };
    }
    if (it.type === "dialog") {
      return {
        ...base,
        type: "dialog",
        dialogueId: it.entry?.dialogueID
      };
    }
  }).filter(it => !!it);
}

export { getNotificationsRequest };
//# sourceMappingURL=api.get-notifications.request.js.map
